export const NotificationEvents = {
    CONNECTED: 'connected',
    MESSAGE: 'message',
    DISCONNECTED: 'disconnected',
    ACCOUNTS_CHANGED: 'accountsChanged',
    NETWORK_CHANGED: 'networkChanged',
    CHAIN_CHANGED: 'chainChanged',
    ERROR: 'error',
};
//# sourceMappingURL=event.js.map